/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/*
 * Size-specific gallery photos (Topgun)
 * Shows only the gallery photos whose alt text matches the selected size
 * (e.g. "4oz" or "2oz"). Photos with no size in their alt text always show.
 */
(function () {
  var SIZE_RE = /(\d+(?:\.\d+)?\s*oz)/i;

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ''); }

  function selectedSize(section) {
    var selects = section.querySelectorAll('[data-option-input]');
    for (var i = 0; i < selects.length; i++) {
      var m = (selects[i].value || '').match(SIZE_RE);
      if (m) return norm(m[1]);
    }
    return null;
  }

  function filterGallery(section) {
    var size = selectedSize(section);
    var list = section.querySelector('.product__subimage-list');
    if (!size || !list) return;
    var items = list.querySelectorAll('.product__subimage-list-item');
    var visible = 0;
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      var m = img ? (img.getAttribute('alt') || '').match(SIZE_RE) : null;
      var show = !m || norm(m[1]) === size;
      items[i].style.display = show ? '' : 'none';
      if (show) visible++;
    }
    // Keep the theme's row layout (rows of 3 / 2) correct for the visible count
    list.className = list.className.replace(/product__subimage-list--r\d/, 'product__subimage-list--r' + (visible % 3));
    list.style.display = visible ? '' : 'none';
    if (window.lazySizes && lazySizes.autoSizer) { lazySizes.autoSizer.checkElems(); }
  }

  function init() {
    var sections = document.querySelectorAll('[data-section-type="product-template"]');
    for (var i = 0; i < sections.length; i++) {
      (function (section) {
        filterGallery(section);
        section.addEventListener('change', function (e) {
          if (e.target && e.target.hasAttribute('data-option-input')) {
            setTimeout(function () { filterGallery(section); }, 0);
          }
        });
      })(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
